import { getMemberBookedSpotName } from './bookedSpotNames';
import {
  getMemberSpotNameFromBookingResult,
  parseBookingSpotBookingsResponse
} from './bookingSpotBookings';
import type { ResolvedMemberSpot } from './eventSpotWire';

/** Pure member-spot resolution from a single booking record (no Redux). */
export function resolveMemberSpotFromBookingRecord(
  booking: Record<string, unknown>
): ResolvedMemberSpot {
  const parsed = parseBookingSpotBookingsResponse(booking);
  const spotName =
    getMemberSpotNameFromBookingResult(parsed) ?? getMemberBookedSpotName(parsed.bookedSpots ?? []);
  if (!spotName) {
    return {};
  }
  return { spotName };
}
